import * as React from 'react'
import Arrow from './Arrow'
import styled, { css } from 'styled-components'
import { yPad } from '../utils/theme'
import { Flex } from 'grid-styled'

interface IContainerProps {
  flushTop: boolean
}

const Container = styled<IContainerProps, any>('section')`
  ${yPad};
  background-image: linear-gradient(0deg, #fafafb 0, #fff 100%);

  ${props =>
    props.flushTop &&
    css`
      padding-top: 3rem !important;
    `};
`

const Testimonial = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  min-height: 280px;
  text-align: center;

  p {
    margin-top: 0;
    font-size: 25px;
    font-weight: 300;
    line-height: 1.68;
    max-width: 800px;

    @media (max-width: 640px) {
      font-size: 19px;
    }
  }

  svg {
    margin: 0 4rem;
    cursor: pointer;

    @media (max-width: 900px) {
      margin: 0 1rem;
    }
  }
`

const Author = styled.div`
  font-size: 1rem;
  font-weight: 300;
  color: #737376;
  -webkit-font-smoothing: subpixel-antialiased;
  letter-spacing: 0.38px;
`

interface IAvatar {
  image: string
}

const Avatar = styled<IAvatar, any>('figure')`
  background: url(${props => props.image});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  width: 60px;
  height: 60px;
  display: inline-block;
  margin-top: 40px;
  border-radius: 100%;
`

interface ITestimonialProps {
  flushTop?: boolean
  style?: object
  testimonials: Array<{
    content: string
    name: string
    company: string
    image: string
  }>
}

export default class extends React.Component<ITestimonialProps> {
  state = {
    i: 0
  }

  prev = () => {
    let i = this.state.i - 1
    i = i < 0 ? this.props.testimonials.length - 1 : i
    this.setState({ i })
  }

  next = () => {
    let i = this.state.i + 1
    i = i >= this.props.testimonials.length ? 0 : i
    this.setState({ i })
  }

  render() {
    const { testimonials, ...rest } = this.props
    const testimonial = testimonials[this.state.i]

    return (
      <Container {...rest}>
        <Testimonial>
          <Flex alignItems="center">
            <Arrow rotate="90deg" onClick={this.prev} />
            <p>{testimonial.content}</p>
            <Arrow rotate="-90deg" onClick={this.next} />
          </Flex>
          <Author>
            {testimonial.name} — {testimonial.company}
          </Author>
          <Avatar image={testimonial.image} />
        </Testimonial>
        <div className="col-1000">
          <div className="controls">
            <div className="dot" data-id="0">
              <div className="inner" data-id="0" />
            </div>
          </div>
        </div>
      </Container>
    )
  }
}
